import React, { useState } from "react";
import * as styles from "./FeaturedVentilador.module.scss";

const FeaturedVentilador = ({ FirtsImg, SecondImg, title }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={styles.img__container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        className={`${styles.img} ${styles.imgBase}`}
        src={FirtsImg}
        alt={title}
      />
      <img
        className={`${styles.img} ${
          isHovered ? styles.imgHovered : styles.imgNotHovered
        }`}
        src={SecondImg}
        alt={title}
      />
      <div className={styles.container__title}>
        <p >{title}</p>
      </div>
    </div>
  );
};

export default FeaturedVentilador;
